import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'split-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
})
export class TabsComponent {
  constructor(private router: Router) {}
  @Input() abaSelecionada: number = 1;
  @Output() abaSelecionadaChange = new EventEmitter<number>();
  abaTaxa: boolean = false;
  abaEmissao: boolean = false;
  abaCliente: boolean = false;
  abaSplit: boolean = false;
  abaBancos: boolean = false;

  onButtonClick(abaSelecionada: number): void {
    /*this.abaTaxa = aba === 'abaTaxa';
    this.abaEmissao = aba === 'abaEmissao';
    this.abaCliente = aba === 'abaCliente';
    this.abaSplit = aba === 'abaSplit';
    this.abaBancos = aba === 'abaBancos';
    this.router.navigate([route]);*/
    this.abaSelecionada = abaSelecionada;
    this.abaSelecionadaChange.emit(abaSelecionada);
  }
}
